import { useTranslation } from "react-i18next";

const rows = [
  { key: "spreadsheet" },
  { key: "productGuides" },
  { key: "qcGuides" },
  { key: "shippingGuides" },
  { key: "warehouseGuide" },
  { key: "safetyGuide" },
];

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t("comparison.h2")}
          </h2>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[540px]">
              <thead>
                <tr className="border-b border-background-200/70 bg-background-100/50">
                  <th className="text-left px-4 md:px-6 py-3 md:py-4 text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                    {t("comparison.headers.resource")}
                  </th>
                  <th className="text-left px-4 md:px-6 py-3 md:py-4 text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                    {t("comparison.headers.bestFor")}
                  </th>
                  <th className="text-left px-4 md:px-6 py-3 md:py-4 text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                    {t("comparison.headers.info")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-200/40 hover:bg-background-100/50 transition-colors">
                    <td className="px-4 md:px-6 py-3 md:py-4 text-sm font-medium text-foreground-950">
                      {t(`comparison.rows.${row.key}.name`)}
                    </td>
                    <td className="px-4 md:px-6 py-3 md:py-4">
                      <span className="inline-flex px-2 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800">
                        {t(`comparison.rows.${row.key}.bestFor`)}
                      </span>
                    </td>
                    <td className="px-4 md:px-6 py-3 md:py-4 text-sm text-foreground-600">
                      {t(`comparison.rows.${row.key}.info`)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            {t("comparison.cta")}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}